module.exports = __webpack_public_path__ + "static/media/master_setting_gray.78ab0405.svg";